import React from "react"

import styles from "./cta.module.css"

const eventTrigger = () => {
  window && window.dataLayer.push({ event: "companySignup" })
}

const CTA = () => {
  return (
    <section className={styles.cta}>
      <div className="wrapper">
        <div className={styles.box}>
          <h2>Como contratar</h2>
          <p>
            Ter a Facio na sua empresa é simples. Entre e em contato agora para
            incluir um benefício moderno que ajuda quem mais precisa e melhora a
            performance da equipe
          </p>
          <p>
            <a
              id="cta_box"
              href="https://faciosalario.typeform.com/to/FLndZa"
              onClick={eventTrigger}
              className="btn"
            >
              Contrate agora
            </a>
          </p>
        </div>
      </div>
    </section>
  )
}

export default CTA
